import EventEmitter from 'events';
// 全局事件监听器(仅用于运行时系统级的事件)
export const wEmitter = new EventEmitter();
export const EventName = {
    ROUTER_BEFORE_EACH: 'router:beforeEach', // 全局前置守卫
    ROUTER_AFTER_EACH: 'router:afterEach', // 全局后置守卫
    // PAGE_INIT: 'page:init', // [Deprecated] 页面初始化(uc-renderer - created)
    PAGE_CREATED: 'page:created', // 页面创建(uc-renderer - created)
    PAGE_MOUNTED: 'page:mounted', // 页面挂载(uc-renderer - mounted)
    PAGE_BEFORE_DESTROY: 'page:beforeDestroy', // 页面销毁前(un-renderer - beforeDestroy)
    PAGE_DESTROYED: 'page:destroyed', // 页面销毁(un-renderer - destroyed)
    PAGE_DATASOURCE_READY: 'page:datasource:ready', // 页面数据源就绪(un-renderer - datasource all-ready)
    PAGE_TITLE_CHANGE: 'page:title:change', // 页面标题修改
};
